import { EditorState, PluginKey } from 'prosemirror-state'
import { State } from './Types'

export const COMMENTS_PLUGIN_KEY = new PluginKey<State>('comments')

export const COMMENT_WS_CHANNEL = 'CommentChannel'

export function getCommentsPluginState(editorState: EditorState) {
  const pluginState = COMMENTS_PLUGIN_KEY.getState(editorState)
  if (!pluginState) {
    throw new Error('Comments plugin is not registered on the current editor state.')
  }
  return pluginState
}
